const eighty = [
  {
    name: 'add',
    type: '80',
    size: '80px'
  },
  {
    name: 'add-new',
    type: '80',
    size: '80px'
  },
  {
    name: 'bank-otc-merchant',
    type: '80',
    size: '80px'
  },
  {
    name: 'broadband',
    type: '80',
    size: '80px'
  },
  {
    name: 'confirmation',
    type: '80',
    size: '80px'
  },
  {
    name: 'customer-support',
    type: '80',
    size: '80px'
  },
  {
    name: 'hosted-backbone',
    type: '80',
    size: '80px'
  },
  {
    name: 'information',
    type: '80',
    size: '80px'
  },
  {
    name: 'internet',
    type: '80',
    size: '80px'
  },
  {
    name: 'organization',
    type: '80',
    size: '80px'
  },
  {
    name: 'pay-as-you-go',
    type: '80',
    size: '80px'
  },
  {
    name: 'play',
    type: '80',
    size: '80px'
  },
  {
    name: 'proactive-alerts',
    type: '80',
    size: '80px'
  },
  {
    name: 'proactive-customized-customer-service',
    type: '80',
    size: '80px'
  },
  {
    name: 'speed',
    type: '80',
    size: '80px'
  },
  {
    name: 'static-ips',
    type: '80',
    size: '80px'
  },
  {
    name: 'strong-india-network',
    type: '80',
    size: '80px'
  },
  {
    name: 'subscriber-advantage',
    type: '80',
    size: '80px'
  },
  {
    name: 'upgrade',
    type: '80',
    size: '80px'
  },
  {
    name: 'upload',
    type: '80',
    size: '80px'
  },
  {
    name: 'user-roles',
    type: '80',
    size: '80px'
  },
  {
    name: 'utilization',
    type: '80',
    size: '80px'
  },
  {
    name: 'warning',
    type: '80',
    size: '80px'
  }
];

export default eighty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/eighty.js